import { useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../../../components/lib/modal";
import CustomerService from "../../../../rest/customerService";
import ConfirmCloseView from "../confirmCloseView";
import NotificationsService from "../../../../rest/notificationService";
import ParentRegisterStepper from "./parentRegisterStepper";

const ParentRegisterModal = ({ isOpen, setIsOpen, sendCredentials }) => {
    const [hasData, setHasData] = useState(false);
    const [confirmClose, setConfirmClose] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const requestClose = () => {
        if (hasData) {
            setConfirmClose(true);
        } else {
            setIsOpen(false);
        }
    };

    const forceClose = () => {
        setConfirmClose(false);
        setIsOpen(false);
    };

    const handleFinish = async ({ parent }) => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const createdParent = await CustomerService.registerParent(parent);
            const parentId = createdParent.id ?? createdParent.id_parent;

            if (!parentId) throw new Error("ID do responsável não retornado");

            const credentials = [];

            if (createdParent.login && createdParent.password) {
                credentials.push({
                    id: parentId,
                    login: createdParent.login,
                    password: createdParent.password
                });
            }

            if (sendCredentials) {
                if (credentials.length > 0) {
                    await NotificationsService.sendUserCredentials(
                        [parentId],
                        credentials
                    );
                }
            }

            toast.success("Cadastro efetuado com sucesso!\nCredenciais enviadas por e-mail.");
            setIsOpen(false);

        } catch (err) {
            console.error("❌ Erro no cadastro:", err);
            toast.error("Erro ao finalizar cadastro.");
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={requestClose}
            title="Efetuar Cadastro"
            hideFooter
        >
            <div className="relative">
                <ParentRegisterStepper
                    onDirty={() => setHasData(true)}
                    onCancel={requestClose}
                    onFinish={handleFinish}
                    isSubmitting={isSubmitting}
                />

                {confirmClose && (
                    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/95 backdrop-blur-sm p-4 rounded-lg">
                        <div className="w-full max-w-sm bg-white shadow-xl rounded-xl border border-gray-200 p-1">
                            <ConfirmCloseView
                                onCancel={() => setConfirmClose(false)}
                                onConfirm={forceClose}
                            />
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ParentRegisterModal;